import React from "react";
import { DialogContainer } from "@/components/ui/dialog";
import { PlanActivationTabsModel, usePlanActivationStore } from "..";

//

export interface InfoTabProps {
  children?: React.ReactNode | ((tabsModel: PlanActivationTabsModel) => React.ReactNode);
}

//

export const InfoTab: React.FC<InfoTabProps> = ({ children }) => {
  const tabsModel = usePlanActivationStore((s) => s.tabsModel);

  return (
    <DialogContainer className="grid" first last>
      {children instanceof Function ? children(tabsModel) : children}
    </DialogContainer>
  );
};
